<template>
  <div class="login-flow">
    <riseup-header>
      <div class="ri-bold-body">
        כניסה
      </div>
    </riseup-header>
    <div class="content">
      <enter-phone-number :next="next" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useRoute, useRouter } from 'vue-router';
import RiseupHeader from '@riseupil/base-ui/src/components/RiseupHeader.vue';
import EnterPhoneNumber from './EnterPhoneNumber.vue';
import Segment from '../../Segment';

const route = useRoute();
const router = useRouter();

const next = async (phoneNumber: string) => {
  const queryParams = { ...route.query, phoneNumber };
  await router.push({ path: '/login-enter-code', query: queryParams });
};
const source = route.query.source as string;
Segment.trackUserGot('Login_EnterPhoneNumber_Shown', { source });
</script>

<style lang="scss" scoped>
  .login-flow {
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;

    .content {
      margin: 30px;
    }
  }
</style>
